/**
 * Organigramma
 * Version 3.8.0.16
 *
 * Copyright (c) 2020 Helios Ciancio
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 * lavoro basato sull'organigramma del Comune di Roma - Italia
 */

import $ from 'jquery'

class Organigramma {
	constructor(element) {
	    if (!element) {
	      throw new Error('Element required to initialize object')
	    }
	    this.element = element
	    this.$element = $(element)
	    this.componentName = 'Organigramma'
	}

    init() {
        this.set()
        this.setMobile()
        var maxHeight = 0
       	this.$element.find( '.Organigramma-clickable .Organigramma-content' ).each( function( ) {
            $( this ).attr( 'data-exh', $( this ).height() )
            if ( $( this ).height() > maxHeight ) {
            	maxHeight = $( this ).height()
            }
        } ).each( function( i, el ) {
            if ( $( el ).attr( 'data-exh' ) < maxHeight ) {
            	$( el ).css( 'padding-top', ( maxHeight - $( el ).height() ) / 2 + 'px' )
            }
            $( el ).css('height', maxHeight + 'px')
        } )
       	this.$element.find( '.Organigramma a, .Organigramma--accordion a' ).on( 'click', function( a ) {
    	    if ( '#' === $( this ).attr( 'href' ) || '' === $( this ).attr( 'href' ) ) a.preventDefault(), a.stopPropagation()
    	} )
    }

    set() {
    	var self = this
        // var items = $( '.Grid-cell > .organigramma-full' )
        var items = this.$element.find( '.organigramma-full' )
        items.addClass( 'closed' )
        $.each( items, function( index, element ) {
            $( element )
            	.find( '.Grid-cell:nth-child(2) .Organigramma' )
            	.addClass( 'Organigramma-clickable' )
            	.toggleClass( 'updownline upline' )
            	.on( 'click', function( item ) {
            		self.toggle(item)
	       		} )
            $( element ).find( '.Grid-cell:gt(1)').hide()
            if ( $( element ).find( '.Grid-cell:nth-child(2) .Organigramma-multicol' ).length > 0 ) {
                self.setMulticolumn( $( element )
            		.addClass( 'Multicol multicol_' + index )
            		.find( '.Grid-cell:nth-child(2) .Organigramma-multicol' )
            		.attr( 'data-open', 'open_' + index )
            		.parent( '.Grid-cell' )
            		.nextAll(), index )
            }
        } )
    }

    setMulticolumn( items, id ) {
        var groups = [],
            columns = {},
            n = 0,
            html = ''
        $.each( items, function( index, element ) {
            var groupName = $( element ).find( '.Organigramma' ).attr( 'data-group' )
            if ( typeof groupName !== typeof undefined && groupName !== false && $.inArray( groupName, groups ) < 0 ) {
            	groups.push( groupName )
            }
            $( element ).show()
        } )
        $.each( groups, function( index, groupName ) {
            var grps = []
            $.each( items, function( i, el ) {
                if ( $( el ).find( '.Organigramma' ).attr( 'data-group' ) === groupName ) {
                	grps.push( el )
                }
            } )
            columns[groupName] = grps
        } )
        $( items.remove() )
        html += '<div class="Organigramma-pushup Grid-cell u-md-sizeFull u-lg-sizeFull" id="multi_' + id + '" style="display: none;"><div class="Grid organigramma-full">'
        $.each( columns, function( index, column ) {
        	if ($( column ).last().find('.updownline').length > 0) {
                $( this ).last().children().removeClass( 'updownline' ).addClass( 'upline' )
        	}
            html += '<div class="Grid-cell u-md-size1of' + groups.length + ' u-lg-size1of' + groups.length + '">'
            if (0 === n) {
                var f = $( '<div />', {
                    html: '<div class="Grid-cell Cell-organigramma-empty"><div class="Organigramma halfdownline Organigramma-verticalonly "><div class="Organigramma-empty"></div></div></div>'
                } )
                f.find( '.Organigramma' ).addClass( 'halfrightline' )
            } else n === groups.length - 1 ? (f = $( '<div />', {
                    html: '<div class="Grid-cell Cell-organigramma-empty"><div class="Organigramma halfdownline Organigramma-verticalonly "><div class="Organigramma-empty"></div></div></div>'
                } ),
                f.find( '.Organigramma' ).addClass( 'halfleftline') ) : (f = $('<div />', {
                html: '<div class="Grid-cell Cell-organigramma-empty"><div class="Organigramma halfdownline Organigramma-verticalonly "><div class="Organigramma-empty"></div></div></div>'
            }), f.find( '.Organigramma' ).addClass( 'rightleftline') )
            html += f.html()
            f = $('<div />', {
                html: '<div class="Grid-cell"><div class="Organigramma highlight Organigramma-multicol Organigramma-verticalonly updownline"><div class="Organigramma-content "><div class="Organigramma-padding"><h3></h3><p></p></div></div></div></div>'
            } )
            f.find( 'h3' ).text( index )
            html += f.html()
            $.each( column, function( i, el ) {
                html += el.outerHTML
            } )
            html += '</div>'
            n++
        } )
        html += '</div></div>'
        $( '.multicol_' + id).parents( '.Grid' ).append( html )
    }

    toggle(event) {
   		$( event.target ).parents( '.Organigramma' ).toggleClass( 'updownline upline' )
        var item = $( event.target ).parents( '.organigramma-full' )
        if ( item.hasClass( 'closed' ) ) {
            var items = $( '.opened' )
            items.toggleClass( 'opened closed' )
       		items.find( '.Grid-cell:nth-child(2)' ).find( '.Organigramma' ).toggleClass( 'updownline upline' )
            items.find( '.Grid-cell:gt(1)' ).hide()
            $( '[id^=multi_]' ).hide()
        }
       	item.find( '.Grid-cell:gt(1)' ).toggle()
        item.toggleClass( 'opened closed' )
        if ( $( event.target ).parents( '.Organigramma' ).attr( 'data-open') ) {
        	event = $( event.target ).parents( '.Organigramma' ).attr( 'data-open' ).replace( 'open_', '#multi_')
        	$( event ).toggle()
        }
    }

    setMobile() {
        //var items = $( '.organigramma-mobile .Accordion' )
        var items = this.$element.find( '.organigramma-mobile .Accordion' )
        $.each( items, function( index, element ) {
            var id = $( element ).attr( 'id' ),
            	groups = []
            $( element ).find( 'p' ).each( function( i, el ) {
                var groupName = $( el ).attr( 'data-group' )
                if ( typeof groupName !== typeof undefined && groupName !== false && $.inArray( groupName, groups ) < 0 ) {
                	groups.push( groupName )
                }
            } )
            if ( groups.length > 0 ) {
            	$.each( groups, function( i, el ) {
	                $( '#' + id + ' .Accordion-panel').append( '<p class="u-text-l u-textWeight-600 u-margin-top-m">' + el + '</p>' )
	                $( '#' + id + ' .Accordion-panel p[data-group="' + el + '"]' ).detach().addClass( 'u-margin-left-m' ).appendTo( '#' + id + ' .Accordion-panel' )
	            } )
            }
        } )
    }
}

export default { Organigramma }



// WEBPACK FOOTER //
// ./src/components/organigramma/organigramma.js